// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { css } from 'styled-components';

// Do not target ::-webkit-scrollbar here. Even `all: revert` opts Chromium into
// custom scrollbar painting and can leave an invisible thumb instead of OS chrome.
export const nativeScrollbarStyles = css`
  scrollbar-width: auto;
  scrollbar-color: auto;
`;

export const nativeVerticalScrollStyles = css`
  ${nativeScrollbarStyles};
  min-height: 0;
  min-width: 0;
  overflow-y: auto;
`;

export const nativeTableHeaderStyles = css`
  ${nativeScrollbarStyles};
  flex-shrink: 0;
  overflow: hidden;
  scrollbar-gutter: stable;
`;

// treact adds transparent side borders to body rows but not header rows.
export const nativeTableRowStyles = css`
  .tr,
  .tr:hover,
  .tr.selected,
  .tr.disabled {
    border-left-width: 0;
    border-right-width: 0;
    box-sizing: border-box;
  }
`;
